import type { MeetingStatus } from '@sl/shared';
import { useTranslation } from 'react-i18next';

const TONE: Record<MeetingStatus, string> = {
  RECORDING: 'live',
  UPLOADED: 'work',
  TRANSCRIBING: 'work',
  DRAFTING: 'work',
  IN_REVIEW: '',
  FINAL: 'done',
  ARCHIVED: '',
  FAILED: 'fail',
};

export function StatusChip({ status }: { status: MeetingStatus }): JSX.Element {
  const { t } = useTranslation();
  return <span className={`chip ${TONE[status]}`}>{t(`statuses.${status}`)}</span>;
}
